export default {
  'time.hour': '{hour} hr',
  'time.min': '{min} min',
  'time.sec': '{sec} sec',
  'time.timezone': 'System Time Zone: {timezone}',
};
